import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
    borderBottom: theme.borders.divider,
    paddingBottom: pxToRem(48),
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      paddingBottom: pxToRem(88),
    },
    '& .MuiContainer-root, & .MuiGrid-root': {
      marginBottom: 0,
    },
  },
  leftTwoColumnSubLayoutSection: {
    ...theme.mixins.marginRight(0),
    [theme.breakpoints.up('lg')]: {
      flexBasis: props => `${get(props, 'params.leftColumnWidth', '')}%`,
      ...theme.mixins.marginRight(theme.spacing(1)),
    },
    '&.MuiGrid-root .MuiGrid-root': {
      margin: 0,
    },
  },
  rightTwoColumnSubLayoutSection: {
    ...theme.mixins.marginLeft(0),
    [theme.breakpoints.up('lg')]: {
      flexBasis: props =>
        `${100 - parseInt(get(props, 'params.leftColumnWidth', ''))}%`,
      ...theme.mixins.marginLeft(theme.spacing(1)),
    },
    '&.MuiGrid-root .MuiGrid-root': {
      margin: 0,
    },
  },
}));

export default useStyles;
